/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 * @param {string} path
 */
export default function parsePath(path) {
    var partialPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            partialPath.hash = path.substr(hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            partialPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
    }
    return partialPath;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/parsePath.js
// module id = null
// module chunks = 